<template>
  <div />
</template>

<script>
export default {
  name: 'account-logout',
  serverPrefetch() {
    return new Promise((resolve, reject) => {
      this.$store.$api.logout()
        .then(r => {
          console.log('logout success', r);
        })
        .catch((e) => {
          console.log('catch logout', e);
        })
        .finally(() => {
          reject({ status: 302, redirect: `/` });
        });
    });
  },
};
</script>
